// ** React Imports
import React, { Fragment, useState, useEffect, useMemo, useRef } from "react";

// ** MUI Components
import {
  Avatar,
  AvatarGroup,
  Stepper,
  StepLabel,
  IconButton,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  InputAdornment,
  Tooltip,
  Paper,
  FormControlLabel,
  FormControl,
  FormLabel,
  Grid,
  Divider,
  ToggleButton,
  ToggleButtonGroup,
  Checkbox,
  Collapse,
  RadioGroup,
  Radio,
} from "@mui/material";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { useTheme } from "@mui/material/styles";

// ** Icon Imports
import Icon from "../../../components/icon";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";

// ** Custom Component Imports
import CustomTextField from "../../../components/mui/text-field";
import CustomChip from "../../../components/mui/chip";
import CustomAvatar from "../../../components/mui/avatar";
import CustomAutocomplete from "../../../components/mui/autocomplete";

// ** Third Party Imports
import dayjs from "dayjs";

import AddServiceDialog from "screens/Assessments/component/AddService";
import AddBundleDialog from "screens/Assessments/component/AddBundle";
import WorkRequirements from "../../Assessments/component/WorkRequirements";

import { useIndexLogic } from "screens/Customers/logic/indexLogic";
import { useCustomerLogic } from "screens/Customers/logic/CustomerLogic";
import { GetJobsite } from "screens/Customers/logic/GetJobsites";
import { SaveServiceRequest } from "screens/Requests/logic/SaveServiceRequest";
import LinkedRecordsComponent from "screens/Requests/component/LinkedRecordsComponent";
import NotesComponent from "screens/Requests/component/NotesComponent";
import AssignToComponent from "screens/Assessments/component/AssignToComponent";
import { GetNotes, DeleteNote } from "screens/Requests/logic/NotesLogic";
import { GetEntityLinks, DeleteLinkRecord } from "screens/Requests/logic/LinkRecordLogic";
import { useWorkRequirementLogic } from "./work-requirement-logic";
import PreAttachment from "screens/Requests/component/PreAttachment";
import { GetServiceRequestRaw } from "screens/Requests/logic/GetServiceRequest";

const Customersteps = [
  {
    icon: "tabler:user",
    title: "Profile Information",
  },
  {
    icon: "tabler:address-book",
    title: "Add Contact",
  },
  {
    icon: "tabler:align-box-bottom-center",
    title: "Add Jobsite",
  },
];

export const useCreateWorkOrderLogic = ({
  handleClose,
  activeStep,
  setActiveStep,
  steps,
  setLoading,
}) => {
  //const theme = useTheme();

  //#region States
  const [openNewCustomerDlg, setOpenNewCustomerDlg] = useState(false);
  const {IndexProps} = useIndexLogic();
  const {fetchData,allCustomers } = IndexProps;

  const {CustomerProps} = useCustomerLogic({activeStep, setActiveStep,Customersteps,setOpenNewCustomerDlg, fetchData, allCustomers});

  const handleAssessmentClose = () => {
    handleClose(false);
    resetRequest();
    ResetWorkRequirement();
  };

  const { 
    setJobsite,
    setCustomer, 
    resetCustomer,
    setAllJobsites, 
    //fetchData, 
    //allCustomers, 
    setOpenNewContactDlg,
    NProgress,
    //StepperHeaderContainer,
    StepJobsite,
    columnsAddContact,
    quickViewOpen,
    contacts,
    jobsite,
    propertyAreaList,
    alertList,
    customer,
    errors, 
    isValidPhone, 
    phoneError,  
    theme,
    searchContactText,
    searchJobsiteText,
    filteredContactRows,
    paginationModelAddContact,
    allJobsites,
    //activeStep,
    openNewContactDlg,
    openUpdateContactDlg,
    toast,
    contactID,      
    openNewJobsiteDlg,
    setOpenNewJobsiteDlg,
    allContacts,
    propertyArea,
    areaMeasurement,
    activeStepJobsite,
    jobsiteContent,
    clearPropertyArea,
    fetchPropertyArea,
    clearAreaMeasurement,
    setActiveStepJobsite,
    setPropertyArea,
    setAreaMeasurement,
    navigate,
    handleOpenNewJobsiteDlg,
    setContactID,
    //handleChange,
    setAlertList,
    handleQuickViewClose,
    handleJobsiteChange,
    handleJobsiteDelete,
    handleJobsiteEdit,
    handleQuickViewOpen,
    handlePhoneFieldChange,
    handleSetPrimary,
    handleDeletePhoneField,
    handleAddPhoneField,
    handleClearContactSearch,
    handleContactSearchChange,
    handleClearJobsiteSearch,
    handleJobsiteSearchChange,
    handleOpenNewContactDlg,
    handleCloseNewContactDlg,  
    handleContactPaginationModel,
    handleCloseUpdateDlg,
    handleNext,
    //handleBack, 
    //setLoading,
    fetchContacts,
    fetchJobsites, 
    handleCloseNewJobsiteDlg,
    files,
    setFiles,
    handleOpenBulkImportContactDlg,
    handleOpenBulkImportJobsiteDlg,
    contact,
    handleContactChange,
    errorContacts,
    handleContactPhoneFieldChange,
    handleSetPrimaryContact,
    handleDeletePhoneFieldContact,
    handleAddPhoneFieldContact,
    isValidContactPhone,
    contactPhoneError,
    handleOpenNewCustomerDlg,
    handleCloseNewCustomerDlg,
    setIsCompleted,
    isCompleted,
    resetJobsite,
    openTagManagementDlg,
    handleCloseTagManagementDlg,
    handleOpenTagManagementDlg,
  } = CustomerProps;

  const initialServiceRequestState = {
    requestID: 0,
    entityType: "WorkOrder",
    requestTitle: null,
    reqDescription: null,
    completeWorkBy: null,
    customerID: 0,
    jobSiteID: 0,
    jobsiteContactID: 0,
    requestSource: null,
    status: null,
    availabilityTime: [],
    availabilityDays: [],
    tags: [],
    assignedToUsers: [],
    isDeposit: false,
    depositAmount: 0
  };
  const [serviceRequest, setServiceRequest] = useState(
    initialServiceRequestState
  );
  const [isServiceEmpty, setIsServiceEmpty] = useState(true);
  const [isBundleEmpty, setIsBundleEmpty] = useState(true);
  const [openServiceDlg, setOpenServiceDlg] = useState(false);
  const [openBundleDlg, setOpenBundleDlg] = useState(false);
  const [formats, setFormats] = useState([]);
  
  // const [ddlArray, setDdlArray] = useState([]);
  const [anytime, setAnyTime] = useState(false);
  const [morning, setMorning] = useState(false);
  const [afternoon, setAfternoon] = useState(false);
  const [evening, setEvening] = useState(false);
  // const [checked, setChecked] = useState([0]);
 

  const [requestErrors, setRequestErrors] = useState({});
  const [Tag, setTag]  = useState('');

  const [requestID, setRequestID] = useState();

  useEffect(() => {
    setRequestID(serviceRequest.requestID);
  }, [serviceRequest])

  const {
    AddServiceProps,
    AddBundleProps,
    WorkRequirementsProps,
    AttachmentProps
  } = useWorkRequirementLogic({requestID: serviceRequest?.requestID, navigate, toast, setLoading, serviceRequest, entity: 'workOrder-create'});

  const {
    handleOpenBundleDlg,
    handleOpenServiceDlg,
    workRequirementList,     
    ResetServicesAndBundlesCollapse,
    ResetWorkRequirement,  
    fetchWorkRequirements 
  } = WorkRequirementsProps;

  const rules = {
    canEdit: true,
  }

  const handleCustomerDropdownChange = (value) => {
    setServiceRequest((prevState) => ({ ...prevState, ['customerID']: value }));
    const getCustomer = allCustomers.filter(x => x.customerID === value)[0];
    setCustomer(getCustomer);
    fetchJobsites2(value);
    fetchContacts(value);
    setIsCompleted(true);
    if (serviceRequest.requestID && serviceRequest.requestID !== 0){
      deletAssociatedNotes(serviceRequest.requestID, "WorkOrder");
      deletAssociatedLinks(serviceRequest.requestID);
    }
    //resetJobsite();    
  }

  const deletAssociatedNotes = async (id, type) => {
    const notesObj = {
      entityID: id,
      entityType: type,
      pageNo: 1,
      recordsPerPage: 1000,
    }
    const associatedNotes = await GetNotes(notesObj);
    
    if (Array.isArray(associatedNotes?.result)) {
      associatedNotes?.result.forEach(note => {
          const { noteID, entityID, entityType } = note; // Destructure the note object
          DeleteNote(noteID, entityID, entityType, "true"); // Call DeleteNote with appropriate arguments
      });
  } else {
      console.error("Notes data is not an array.");
  }
    
  }

  const deletAssociatedLinks = async (id) => {

    const associatedLinks = await GetEntityLinks(id);

    // console.log(id)
    
    if (Array.isArray(associatedLinks)) {
      associatedLinks.forEach(link => {
          const { id, toEntityId } = link; // Destructure the note object
          DeleteLinkRecord(id, toEntityId, "true"); // Call DeleteNote with appropriate arguments
      });
  } else {
      console.error("Link data is not an array.");
  }
  }
  const handleJobsiteDropdownChange = (value) => {
    setServiceRequest((prevState) => ({ ...prevState, ['jobSiteID']: value }));
   // getJobSiteContacts(value);
    const getJobsite = allJobsites.filter(x => x.jobsiteID === value)[0];
    setJobsite(getJobsite);
  }
  const handleContactDropdownChange = (value) => {
    setServiceRequest((prevState) => ({ ...prevState, ['jobsiteContactID']: value }));
  }
  const handleTitleChange = (value) => {
    setServiceRequest((prevState) => ({ ...prevState, ['requestTitle']: value }));
  }

  const handlePreferredDaysChange = (value) => {
    setServiceRequest((prevState) => ({ ...prevState, ['availabilityDays']: value }));
  }

  const handleTimeChange = (field, value) => {
    setServiceRequest((prevState) => {
      // Create a copy of the current availabilityTime array
      const currentAvailabilityTime = [...(prevState.availabilityTime || [])];
  
      // Define a mapping for time fields to their corresponding values
      const timeMapping = {
        anytime: 1,
        morning: 2,
        afternoon:3,        
        evening: 4,
      };
  
      const timeValue = timeMapping[field];
  
      if (value) {
        // Add the time value if it is checked and not already in the array
        if (!currentAvailabilityTime.includes(timeValue)) {
          currentAvailabilityTime.push(timeValue);
        }
      } else {
        // Remove the time value if it is unchecked
        const index = currentAvailabilityTime.indexOf(timeValue);
        if (index > -1) {
          currentAvailabilityTime.splice(index, 1);
        }
      }
  
      // Update the state with the new availabilityTime array
      return { ...prevState, availabilityTime: currentAvailabilityTime };
    });
  
    // Update the specific checkbox states
    if (field === "anytime") { 
      setAnyTime(value);
      if(value === true){
        setMorning(true);
        setAfternoon(true);
        setEvening(true);
      }
      if(value === false){
        setMorning(false);
        setAfternoon(false);
        setEvening(false);
      }
    }else{
      setAnyTime(false);
      if (field === "morning") setMorning(value);
      if (field === "evening") setEvening(value);
      if (field === "afternoon") setAfternoon(value);  
    }
  };

  const fetchJobsites2 = async (customerID = serviceRequest.customerID) => {
    try {
      if(customerID){
        let jobs = await GetJobsite(customerID, 0, navigate);
        setAllJobsites(jobs);
      }else{
        setAllJobsites([]);
      }
      
    } catch (error) {
      console.error("Error fetching Jobsite data:", error);
    }
  };

  const handleCompleteWorkByDateChange = (value) => {
    setServiceRequest((prevState) => ({ ...prevState, ['completeWorkBy']: new Date(value) }));
  }

  const handleCloseContactDialog = async () =>{
     try {
    await fetchContacts(customer?.customerID);
    handleCloseNewContactDlg();    
  } catch (error) {
    console.error('Error fetching contacts or closing dialog:', error);
  }
  }

  const handleDeleteTag = (tagName) => {
    setServiceRequest(prev => ({
        ...prev,
        tags: prev.tags.filter(tag => tag.tagName !== tagName)
    }));
  };
  const handleAddTag = (tagName) => {

    if(tagName == '') return false;
    const lowerCaseTagName = tagName.toLowerCase();

    setServiceRequest((prev) => {
        
        const tagExists = prev.tags?.some(tag => tag.tagName.toLowerCase() === lowerCaseTagName);

        if (tagExists) {
            return prev; 
        }
        const updatedTags = {
            ...prev,
            tags: [...(prev.tags || []), { tagName }]
        };
        return updatedTags;
    });
    setTag('');
    //document.getElementById('TxtTag').value = '';
  };

  useEffect(() => {
      if (Object.keys(requestErrors).length > 0) {
        const timer = setTimeout(() => {
          setRequestErrors([]);
        }, 5000);
        return () => clearTimeout(timer);
      }
      }, [requestErrors]);
  

  const validateRequestField = () => {
    let tempErrors = {};

    if (!serviceRequest.requestTitle)
      tempErrors.requestTitle = 'Work Order Title is required';

    if (serviceRequest.isDeposit && !serviceRequest.depositAmount)
      tempErrors.depositAmount = 'Deposit Amount must be greater than 0';

    if (!serviceRequest.customerID)
      tempErrors.customerID = 'Customer is required';

    if (!serviceRequest.jobSiteID || !allJobsites?.some((jobsite) => jobsite.jobsiteID === serviceRequest?.jobSiteID))
      tempErrors.jobSiteID = 'Jobsite is required';

    if (!serviceRequest.jobsiteContactID || !contacts?.some((contact) => contact.id === serviceRequest?.jobsiteContactID))
      tempErrors.jobsiteContactID = 'Jobsite Contact is required';

    setRequestErrors(tempErrors);
    return (Object.keys(tempErrors).length === 0);
  }

  const formatCurrencyDisplay = (value) => {
    if (value === '' || value === null || value === undefined) return '';
    const num = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
    return isNaN(num) ? '' : num.toLocaleString();
  };

  const handleServiceRequestChange = (field, value) => {
    if (field === 'depositAmount') {
      const numericValue = value.replace(/[^0-9.]/g, '');
      
      if (numericValue === '' || !isNaN(numericValue)) {
        setServiceRequest(prev => ({ ...prev, [field]: Number(numericValue) }));
      }
    } else {
      setServiceRequest(prev => ({ ...prev, [field]: value }));
    }
  };

  const SaveService = async (oldService) => {
    try {                        
      const response = await SaveServiceRequest(oldService ? oldService : serviceRequest, navigate, 'WorkOrder');     
      if (response && !response.isError) { 
        handleServiceRequestChange('requestID',response?.result?.requestID);
        return true;                 
      }
      else{
        return false;
      }
       
    } catch (error) {
      console.error('Error saving serviceRequest:', error);          
    }
  };
  
  
    const handleSaveAsDraft = () => {
      if (toast) {
        toast.success("The Work Order has been saved as draft", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: {
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '15px',
          },
        });
      }
    };
  const handleWorkOrderNext = async () => {
    if(validateRequestField()){
      if (activeStep === 0) {
        SaveService();
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        ResetServicesAndBundlesCollapse();
      }
      if (activeStep === 1 || activeStep === 2 || activeStep === 3 || activeStep === 4) {
        ResetServicesAndBundlesCollapse();
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
  
      if (activeStep === steps.length - 1) {
        const b = await SaveService();
        if(b){
          toast.success(`New Work Order created successfully!`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });  
        } else {
          toast.error(`Work Order creation failed. Please try again.`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });  
        }
        handleAssessmentClose();
        setActiveStep(0);
      }
    }  
  };

  const resetRequest = () =>{
    setServiceRequest(initialServiceRequestState);
    setFormats([]);
    setAnyTime(false);
    setMorning(false);
    setAfternoon(false);
    setEvening(false);
    setAllJobsites([]);
    resetCustomer();
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  useEffect(() => {
    if (morning && evening && afternoon) setAnyTime(true);
  }, [morning, evening, afternoon, anytime]);

  const handleFormat = (event, newFormats) => {
    setFormats(newFormats);
    const availableDays = Object.keys(newFormats);
    handlePreferredDaysChange(availableDays.map((item) => 1 * item + 1));
  };  
  //#endregion end of states

  //#region Handlers and methods


  const allDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  
  const dayToNumberMap = {
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
    Sun: 0,
  };

  const parseAvailabilityDays = (daysString) => {
    try {
      const daysArray = JSON.parse(daysString);
      // Ensure that only numbers are kept in the array
      return daysArray.filter((item) => typeof item === 'number');
    } catch (error) {
      //console.error('Error parsing availabilityDays:', error);
      return [];
    }
  };

  const availabilityDaysArray = parseAvailabilityDays(serviceRequest.availabilityDays || "[]");

  const handleDayChange = (day) => {
    // Parse the availabilityDays string into an actual array of numbers
    let updatedDays = serviceRequest.availabilityDays
      ? parseAvailabilityDays(serviceRequest.availabilityDays)
      : [];

    // Get the numeric value of the selected day (e.g., "Mon" -> 1)
    const dayNumber = dayToNumberMap[day];

    // Toggle the day in the list
    if (updatedDays.includes(dayNumber)) {
      // If the day is already selected, remove it
      updatedDays = updatedDays.filter((d) => d !== dayNumber);
    } else {
      // If the day is not selected, add it
      updatedDays.push(dayNumber);
    }

    // Update the serviceRequest state, storing only numbers
    setServiceRequest((prevState) => ({
      ...prevState,
      availabilityDays: JSON.stringify(updatedDays), // Store as a clean stringified array of numbers
    }));
  };


  useEffect(() => {
    if (morning && evening && afternoon) setAnyTime(true);
  }, [morning, evening, afternoon, anytime]);

  

  // const handleToggle = (value) => () => {
  //   const currentIndex = checked.indexOf(value);
  //   const newChecked = [...checked];
  //   if (currentIndex === -1) {
  //     newChecked.push(value);
  //   } else {
  //     newChecked.splice(currentIndex, 1);
  //   }
  //   setChecked(newChecked);
  // };

  //const handleOpenServiceDlg = () => setOpenServiceDlg(true);
  //const handleCloseServiceDlg = () => setOpenServiceDlg(false);
  
  //const handleOpenBundleDlg = () => setOpenBundleDlg(true);
  //const handleCloseBundleDlg = () => setOpenBundleDlg(false);

  // const handleSave = () => {
  //   handleCloseBundleDlg();
  //   handleCloseServiceDlg();
  //   setIsBundleEmpty(false);
  //   setIsServiceEmpty(false);
  // }

  const fetchRequests = async (RequestID = requestID, loading = true) => { 
    try {
      setLoading(true);      
      let RequestRaw = await GetServiceRequestRaw(0, RequestID);
      const newRequest = RequestRaw.result[0];
      setServiceRequest(newRequest);
    } catch (error) {
      console.error("Error fetching Requests data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Fragment>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              <Box
                sx={{
                  maxWidth: { xs: "100%", lg: "50%" },
                }}
              >
                <Grid container spacing={5}>
                  <Grid item xs={12}>
                    <Divider
                      sx={{
                        color: "text.disabled",
                        "& .MuiDivider-wrapper": { px: 6 },
                        fontSize: theme.typography.body2.fontSize,
                        my: (theme) => `${theme.spacing(3)} !important`,
                      }}
                    >
                      Basic Information
                    </Divider>
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <CustomTextField
                      fullWidth
                      label="Work Order Title"
                      required
                      placeholder="Enter a brief work order title…"
                      value={serviceRequest?.requestTitle || ""}
                      onChange={(e) => handleTitleChange(e.target.value)}
                      error={!!requestErrors.requestTitle}
                      helperText={requestErrors.requestTitle}
                    />
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <CustomTextField
                      fullWidth
                      label="Description"
                      multiline
                      rows={2}
                      placeholder="Add a description..."
                      value={serviceRequest?.reqDescription || ""}
                      onChange={(e) =>
                        handleServiceRequestChange(
                          "reqDescription",
                          e.target.value
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <Box
                      sx={{
                        border: "1px solid #DBDBDB",
                        borderRadius: 1,
                        p: 2,
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="success"
                            checked={serviceRequest?.isDeposit || false}
                            onChange={(e) =>
                              handleServiceRequestChange(
                                "isDeposit",
                                e.target.checked
                              )
                            }
                          />
                        }
                        label={
                          <>
                            <Typography variant="body1" color="text.primary">
                              Deposit Required
                            </Typography>
                            <Typography variant="caption">
                              Check this if a deposit is required
                            </Typography>
                          </>
                        }
                      />
                    </Box>
                  </Grid>
                  {serviceRequest?.isDeposit && (
                    <Grid item xs={12} md={10} lg={6}>
                      <CustomTextField
                        fullWidth
                        required
                        label="Deposit Amount"
                        placeholder="Enter deposit amount"
                        value={formatCurrencyDisplay(
                          serviceRequest?.depositAmount
                        )}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(
                            /[^0-9.]/g,
                            ""
                          );
                          handleServiceRequestChange(
                            "depositAmount",
                            numericValue
                          );
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        error={!!requestErrors.depositAmount}
                        helperText={requestErrors.depositAmount}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Divider
                      sx={{
                        color: "text.disabled",
                        "& .MuiDivider-wrapper": { px: 6 },
                        fontSize: theme.typography.body2.fontSize,
                        my: (theme) => `${theme.spacing(3)} !important`,
                      }}
                    >
                      General Information
                    </Divider>
                  </Grid>
                 <Grid item xs={12} md={10}>
                  <CustomAutocomplete
                    fullWidth
                    required
                    options={[
                      { customerID: "create_new", label: "+ Create New Customer", isCreateOption: true },
                      ...(allCustomers
                        ? [...allCustomers].map(customer => {
                            const value = customer.customerID;
                            const label = customer.customerType === "Individual"
                              ? `${customer.firstName ?? ""} ${customer.lastName ?? ""}`.trim()
                              : customer.companyName ?? "";
                            return value ? { value, label, customerType: customer.customerType, firstName: customer.firstName, lastName: customer.lastName, companyName: customer.companyName } : null;
                          })
                          .filter(Boolean)
                          .sort((a, b) => a.label.localeCompare(b.label))
                        : [])
                    ]}
                    getOptionLabel={(option) => option.label || ""}
                    value={
                      serviceRequest?.customerID && serviceRequest.customerID !== ""
                        ? (() => {
                            const selectedCustomer = allCustomers?.find(customer => 
                              customer.customerID === serviceRequest.customerID
                            );
                            
                            if (selectedCustomer) {
                              const label = selectedCustomer.customerType === "Individual"
                                ? `${selectedCustomer.firstName ?? ""} ${selectedCustomer.lastName ?? ""}`.trim()
                                : selectedCustomer.companyName ?? "";
                              return { 
                                value: serviceRequest.customerID, 
                                label: label 
                              };
                            }
                            return null;
                          })()
                        : null
                    }
                    onChange={(event, newValue) => {
                      if (newValue?.isCreateOption) {
                        handleOpenNewCustomerDlg();
                      } else if (newValue) {
                        handleCustomerDropdownChange(newValue.value);
                      }
                    }}
                    isOptionEqualToValue={(option, value) => option.value === value?.value}
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        required
                        label="Customer Name"
                        placeholder="Select Customer"
                        error={!!requestErrors.customerID}
                        helperText={requestErrors.customerID}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props}>
                        <span style={{ 
                          fontWeight: option.isCreateOption ? 'bold' : 'normal',
                        }}>
                          {option.label}
                        </span>
                      </li>
                    )}
                    filterOptions={(options, { inputValue }) => {
                      if (!inputValue) return options;
                      
                      return options.filter(option =>
                        option.isCreateOption || option.label.toLowerCase().includes(inputValue.toLowerCase())
                      );
                    }}
                  />
                </Grid>              
                <Grid item xs={12} md={10}>
                  <CustomAutocomplete
                    fullWidth
                    required
                    disabled={!customer?.customerID}
                    options={[
                      { value: "create-new", label: "+ Create New Jobsite", isCreateOption: true },
                      ...((allJobsites || [])
                        .map(jobsite => {
                          const value = jobsite.jobsiteID;
                          const label = jobsite.jobsiteName;
                          return value && label ? { value, label } : null;
                        })
                        .filter(Boolean)
                        .sort((a, b) => a.label.localeCompare(b.label)))
                    ]}
                    getOptionLabel={(option) => option.label || ""}
                    value={
                      serviceRequest?.jobSiteID && serviceRequest.jobSiteID !== ""
                        ? (() => {
                            const selectedJobsite = allJobsites?.find(jobsite => 
                              jobsite.jobsiteID === serviceRequest.jobSiteID
                            );
                            
                            if (selectedJobsite) {
                              return { 
                                value: serviceRequest.jobSiteID, 
                                label: selectedJobsite.jobsiteName || "" 
                              };
                            }
                            return null;
                          })()
                        : null
                    }
                    onChange={(event, newValue) => {
                      if (newValue?.isCreateOption) {
                        if (customer?.customerID) {
                          handleOpenNewJobsiteDlg();
                        }
                      } else if (newValue) {
                        handleJobsiteDropdownChange(newValue.value);
                      }
                    }}
                    isOptionEqualToValue={(option, value) => option.value === value?.value}
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        label="Jobsite"
                        required
                        placeholder="Select Jobsite"
                        error={!!requestErrors.jobSiteID}
                        helperText={requestErrors.jobSiteID}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props}>
                        <span style={{ 
                          fontWeight: option.isCreateOption ? 'bold' : 'normal',
                          color: option.isCreateOption && !customer?.customerID ? 'rgba(0, 0, 0, 0.38)' : 'inherit',
                        }}>
                          {option.label}
                        </span>
                      </li>
                    )}
                    filterOptions={(options, { inputValue }) => {
                      if (!inputValue) return options;
                      
                      return options.filter(option =>
                        option.isCreateOption || option.label.toLowerCase().includes(inputValue.toLowerCase())
                      );
                    }}
                  />
                </Grid>
                  <Grid item xs={12} md={10}>
                  <CustomAutocomplete
                    fullWidth
                    required
                    disabled={!customer?.customerID > 0}
                    id="jobsite-contact-autocomplete"
                    options={[
                      { value: "create-new", label: "+ Create New Contact", isCreateOption: true },
                      ...((contacts || [])
                        .map(contact => {
                          const value = contact.id;
                          const label = contact.contact;
                          return value && label ? { value, label } : null;
                        })
                        .filter(Boolean)
                        .sort((a, b) => a.label.localeCompare(b.label)))
                    ]}
                    getOptionLabel={(option) => option.label || ""}
                    value={
                      serviceRequest?.jobsiteContactID && serviceRequest.jobsiteContactID !== ""
                        ? (() => {
                            const selectedContact = contacts?.find(contact => 
                              contact.id === serviceRequest.jobsiteContactID
                            );
                            
                            if (selectedContact) {
                              return { 
                                value: serviceRequest.jobsiteContactID, 
                                label: selectedContact.contact || "" 
                              };
                            }
                            return null;
                          })()
                        : null
                    }
                    onChange={(event, newValue) => {
                      if (newValue?.isCreateOption) {
                        handleOpenNewContactDlg();
                      } else if (newValue) {
                        handleContactDropdownChange(newValue.value);
                      }
                    }}
                    isOptionEqualToValue={(option, value) => option.value === value?.value}
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        label="Jobsite Contact"
                        required
                        placeholder="Select Jobsite Contact"
                        error={!!requestErrors.jobsiteContactID}
                        helperText={requestErrors.jobsiteContactID}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props}>
                        <span style={{ 
                          fontWeight: option.isCreateOption ? 'bold' : 'normal',
                        }}>
                          {option.label}
                        </span>
                      </li>
                    )}
                    filterOptions={(options, { inputValue }) => {
                      if (!inputValue) return options;
                      
                      return options.filter(option =>
                        option.isCreateOption || option.label.toLowerCase().includes(inputValue.toLowerCase())
                      );
                    }}
                  />
                </Grid>   
                </Grid>
              </Box>
              <Box>
                <Divider
                  orientation="vertical"
                  sx={{ height: "100%", mx: 6 }}
                />
              </Box>
              <Box
                sx={{
                  maxWidth: { xs: "100%", lg: "50%" },
                }}
              >
                <Grid container spacing={5}>
                  <Grid item xs={12}>
                    <Divider
                      sx={{
                        color: "text.disabled",
                        "& .MuiDivider-wrapper": { px: 6 },
                        fontSize: theme.typography.body2.fontSize,
                        my: (theme) => `${theme.spacing(3)} !important`,
                      }}
                    >
                      Availability Details
                    </Divider>
                  </Grid>
                  <Grid item xs={12}>
                    <Box marginBottom="4px">
                      <FormLabel
                        sx={{
                          fontSize: "13px",
                          color: "text.primary",
                          fontWeight: 400,
                        }}
                      >
                        Preferred Days
                      </FormLabel>
                    </Box>
                    <ToggleButtonGroup value={availabilityDaysArray}>
                      {allDays.map((day, index) => {
                        const dayNumber = dayToNumberMap[day];
                        return (
                          <ToggleButton
                            // disabled={dayNumber > 5 || dayNumber === 0}
                            key={index}
                            value={day}
                            color={"info"}
                            selected={availabilityDaysArray.includes(dayNumber)} // Mark selected ones
                            onChange={() => handleDayChange(day)}
                             sx={{
                              fontSize: { xs: "11px", sm: "13px" },
                              px: { xs: 1, sm: 2 },
                              minWidth: { xs: "40px", sm: "60px" },
                            }}
                          >
                            {day}
                          </ToggleButton>
                        );
                      })}
                    </ToggleButtonGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <FormLabel
                      sx={{
                        fontSize: "13px",
                        color: "text.primary",
                        fontWeight: 400,
                      }}
                    >
                      Preferred Times
                    </FormLabel>
                    <Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            value="anytime"
                            color="success"
                            checked={anytime}
                            onChange={(e) =>
                              handleTimeChange("anytime", e.target.checked)
                            }
                          />
                        }
                        label="Anytime"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            value="morning"
                            color="success"
                            checked={morning}
                            onChange={(e) =>
                              handleTimeChange("morning", e.target.checked)
                            }
                          />
                        }
                        label="Morning"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            value="afternoon"
                            color="success"
                            checked={afternoon}
                            onChange={(e) =>
                              handleTimeChange("afternoon", e.target.checked)
                            }
                          />
                        }
                        label="Afternoon"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            value="evening"
                            color="success"
                            checked={evening}
                            onChange={(e) =>
                              handleTimeChange("evening", e.target.checked)
                            }
                          />
                        }
                        label="Evening"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormLabel
                      sx={{
                        fontWeight: 400,
                        fontSize: "13px",
                        marginBottom: "4px",
                        color: "text.primary",
                        height: "100%",
                      }}
                    >
                      Complete work by
                    </FormLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        sx={{ width: "100%" }}
                        slotProps={{ textField: { size: "small" } }}
                        value={
                          serviceRequest.completeWorkBy &&
                          serviceRequest.completeWorkBy !==
                            "0001-01-01T00:00:00" &&
                          serviceRequest.completeWorkBy !==
                            "1900-01-01T00:00:00"
                            ? dayjs(serviceRequest.completeWorkBy)
                            : null
                        }
                        onChange={(newValue) => {
                          handleCompleteWorkByDateChange(newValue);
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider
                      sx={{
                        color: "text.disabled",
                        "& .MuiDivider-wrapper": { px: 6 },
                        fontSize: theme.typography.body2.fontSize,
                        my: (theme) => `${theme.spacing(3)} !important`,
                      }}
                    >
                      Additional Details
                    </Divider>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", alignItems: "center", pb: 8 }}
                  >
                    <Typography variant="body1" sx={{ mr: 6 }}>
                      Tags
                    </Typography>
                    <IconButton
                      onClick={() => {
                        handleOpenTagManagementDlg();
                      }}
                    >
                      <AddIcon />
                    </IconButton>

                    {serviceRequest?.tags && serviceRequest.tags.length > 0 ? (
                      serviceRequest.tags.map((tag) => (
                        <CustomChip
                          label={tag.tagName}
                          skin="light"
                          color="info"
                          deleteIcon={
                            <Tooltip title="Click to remove tag">
                              <CloseIcon />
                            </Tooltip>
                          }
                          onDelete={() => handleDeleteTag(tag.tagName)}
                          sx={{
                            cursor: "pointer",
                            mr: 2,
                            mb: 2,
                          }}
                        />
                      ))
                    ) : (
                      <Typography variant="body2" sx={{ ml: 2 }}>
                        Add tags
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Fragment>
        );
      case 1:
        return (
          <>
            <Grid container spacing={5}>
              {(workRequirementList &&  workRequirementList.length === 0) ? (
              <>
                <Grid item xs={12} md={6}>
                  <Card>
                    <CardContent
                      sx={{
                        display: "flex",
                        textAlign: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : "#FBFBFC",
                        p: (theme) =>
                          `${theme.spacing(9.75, 5, 9.25)} !important`,
                      }}
                    >
                      <CustomAvatar skin="light" color="info" sx={{ mb: 2.25 }}>
                        <Icon icon='tabler:building' />
                      </CustomAvatar>
                      <Typography variant="h5" sx={{ mb: 2.75 }}>
                        No Bundles added yet
                      </Typography>
                      <Typography sx={{ mb: 6, color: "text.secondary" }}>
                      Add bundles that are required by clicking on
                      “Add Bundle” button
                      </Typography>
                      <Button
                        variant="outlined"
                        color={theme.palette.mode === 'dark' ? "secondary" : "primary"}
                        startIcon={<AddIcon color="info" />}
                        onClick={handleOpenBundleDlg}
                      >
                        Add Bundle
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Card>
                    <CardContent
                      sx={{
                        display: "flex",
                        textAlign: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : "#FBFBFC",
                        p: (theme) =>
                          `${theme.spacing(9.75, 5, 9.25)} !important`,
                      }}
                    >
                      <CustomAvatar skin="light" color="info" sx={{ mb: 2.25 }}>
                        <Icon icon='tabler:building' />
                      </CustomAvatar>
                      <Typography variant="h5" sx={{ mb: 2.75 }}>
                        No Services added yet
                      </Typography>
                      <Typography sx={{ mb: 6, color: "text.secondary" }}>
                      Add services that are required by clicking on
                      “Add Service” button
                      </Typography>
                      <Button
                        variant="outlined"
                        color={theme.palette.mode === 'dark' ? "secondary" : "primary"}
                        startIcon={<AddIcon color="info" />}
                        onClick={handleOpenServiceDlg}
                      >
                        Add Service
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              </>
              ) : (
                <WorkRequirements 
                  entity='workOrder' 
                  {...WorkRequirementsProps}
                  rules={rules} 
                  requestID={serviceRequest?.requestID}
                  fetchRequests={fetchRequests}
                />
              )}
            </Grid>
            <AddServiceDialog
              {...AddServiceProps}
            />

            <AddBundleDialog
              {...AddBundleProps}
            />

            <PreAttachment
              Title="Upload Attachment"
              {...AttachmentProps}
            />
          </>
        );
      case 2: 
        return (
          <>
            <Grid container spacing={5}>
                <WorkRequirements 
                  entity='workOrder-schedule' 
                  method='create'
                  {...WorkRequirementsProps}
                  rules={rules} 
                  requestID={serviceRequest?.requestID}
                  fetchRequests={fetchRequests}
                />
            </Grid>
          </>
        );
      case 3:
        return (
          <Fragment>
            <Grid container spacing={5}>
              <Grid item xs={12}>
                <LinkedRecordsComponent 
                  requestID={serviceRequest?.requestID} 
                  customerID={serviceRequest?.customerID}
                  setLoading={setLoading}
                  module="creation"
                  rules={rules}
                />
              </Grid>
            </Grid>
          </Fragment>
        );
      case 4:
        return (
          <Fragment>
            <Grid container spacing={5} >
            <Grid item xs={12}> 
            <Box
              sx={{
                height: "69vh",
              }}
            >
          <NotesComponent 
            requestID={serviceRequest?.requestID}
            requestType={"workorder"}
            customerID={serviceRequest?.customerID}
            setLoading={setLoading}
            rules={rules}
            module="creation"
          />  
          </Box>
              </Grid>
            </Grid>
          </Fragment>
        );
      case 5:
        return (
          <Fragment key={step}>
            <Grid container spacing={5}>
              <AssignToComponent 
                requestID={serviceRequest?.requestID}
                serviceRequest={serviceRequest}
                requestType={"WorkOrder"}                
                setLoading={setLoading}
                rules={rules}
                navigate= {navigate} 
                handleServiceRequestChange={handleServiceRequestChange}                
              />
            </Grid>
          </Fragment>
        );
      default:
        return "Unknown Step";
    }
  };

  const renderContent = () => {
    return (
      <form onSubmit={(e) => e.preventDefault()} style={{ height: '100%' }}>
          {getStepContent(activeStep)}
      </form>
    );
  };

  //#endregion end of handlers and methods

  const CreateWorkOrderProps = {
    renderContent,
    getStepContent,
    handleFormat,
    handleWorkOrderNext,
    handleBack,
    activeStep,
    formats,    
    allCustomers,
    allContacts,
    openNewCustomerDlg,
    setOpenNewCustomerDlg,
    fetchData,
    openNewContactDlg,
    handleCloseContactDialog,
    customer,
    setLoading,
    fetchContacts,   
    toast,   
      openNewJobsiteDlg,
    setOpenNewJobsiteDlg,
    propertyArea,
    areaMeasurement,
    activeStepJobsite,
    jobsiteContent,
    clearPropertyArea,
    fetchPropertyArea,
    clearAreaMeasurement,
    setActiveStepJobsite,
    setPropertyArea,
    setAreaMeasurement,
    navigate,
    setAlertList,
    handleJobsiteChange,
    handleCloseNewJobsiteDlg,
    alertList,
    files,
    setFiles,
    jobsite,
    NProgress,
    fetchJobsites,
    propertyAreaList,              
    allContacts,
    openTagManagementDlg,
    handleCloseTagManagementDlg,              
    handleAddTag,
    handleDeleteTag,
    serviceRequest,
    setServiceRequest,
    Tag,
    setTag,
    resetRequest,
    handleCustomerDropdownChange,
    requestErrors,
    handleJobsiteDropdownChange,
    handleContactDropdownChange,
    handleCompleteWorkByDateChange,
    SaveService,
    validateRequestField,
    handleOpenNewJobsiteDlg,
    handleOpenNewContactDlg,
    handleTimeChange,
    fetchPropertyArea,
    setRequestErrors,
    AddServiceProps,
    AddBundleProps,
    WorkRequirementsProps,
    AttachmentProps,
    ResetWorkRequirement,
    handleServiceRequestChange,
    formatCurrencyDisplay,
    handleSaveAsDraft,
  };

  return {
    CreateWorkOrderProps,
  };
};
